import React, { useEffect, useState } from "react";
import { getConfig, searchAPI } from "../../apis";
import { useDispatch, useSelector } from "react-redux";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import CustomLoader from "../../components/loader";
import { useParams } from "react-router-dom";
import { Tooltip } from "@mui/material";
import PopupSave from "./PopupSave";
import {
  setBookmarkUrls,
  setCitationPopup,
  setCollections,
  setSummaryInfoData,
  setUrl,
} from "../../redux/features/dataSlice";
import CustomSummarize from "../NewsPage/uis/SectionNews/CustomSummarize";
import Summarize from "../NewsPage/uis/SectionNews/Summarize";
import NewBookmark from "../NewsCategoryPage/NewBookmark";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PopupCitation from "../SavedPage/popup/PopupCitation";
import { toast } from "react-toastify";
import { getRegularDate } from "../../functions/time";
import { axiosInstance } from "../../functions/axios";
import useDocumentTypes from "../../hooks/useDocumentTypes";

const WikipediaPage = () => {
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState([]);
  const [error, setError] = useState(null);
  const [newBookmarkPopup, setNewBookmarkPopup] = useState(false);

  const [selectedCollection, setselectedCollection] = useState();
  const [popup, setpopup] = useState(false);
  const [page, setPage] = useState({});

  const [isDescExternal, setIsDescExternal] = useState(false);
  const [desc, setDesc] = useState("");
  const [summaryText, setSummaryText] = useState("");
  const [summarizePopupNa, setSummarizePopupNa] = useState(false);

  const [bookmarkdata, setBookmarkData] = useState({});
  const [citation, setCitation] = useState("");
  const [articleData, setArticleData] = useState({});

  const params = useParams();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  useDocumentTypes(user.userId);
  const { search, bookmarkUrls, summaryPopup, summarizePopup, citationPopup } =
    useSelector((state) => state.data);

  const getBookmarks = async () => {
    const res = await axiosInstance.post(
      searchAPI.getCollectionsSource,
      {
        callingUserId: user.userId,
        userId: user.userId,
      },
      getConfig()
    );
    dispatch(
      setBookmarkUrls(res.data.map((bookmark) => bookmark.sourceUrl_chr))
    );
  };

  const fetchData = async () => {
    setLoading(true);

    let searchTerm = search;
    if (search === "") {
      if (params.query) {
        searchTerm = params.query;
      }
    }

    try {
      const { data } = await axiosInstance.post(
        searchAPI.searchEncylopedia,
        {
          searchTerm: searchTerm,
          count: "21",
        },
        getConfig()
      );
      setPages(data.data.webPages.value);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  const checkBookmark = (url) => {
    if (bookmarkUrls.includes(url)) {
      return true;
    }
    return false;
  };

  const handleClick = (page) => {
    setpopup(!popup);
    setPage({
      ...page,
      title: page.name,
      sourcePublishedDateTime: page.datePublished,
    });
  };

  async function getCollectionData() {
    const res = await axiosInstance.post(
      searchAPI.getCollections,
      {
        callingUserId: user.userId,
        userId: user.userId,
      },
      getConfig()
    );

    let newArr = [];
    res.data.forEach((item) =>
      newArr.push({
        name: item.collectionName_chr,
        value: item.collectionName_chr,
        collectionId: item.collectionID_ids,
        parentCollectionId: item.parentCollectionID_lng,
      })
    );
    newArr = newArr.reverse();
    dispatch(setCollections(newArr));
    setselectedCollection(JSON.stringify(newArr[0]));
  }

  const saveCollectionFolder = async (name) => {
    const requestsData = {
      callingUserId: user.userId,
      userId: user.userId,
      collectionName: name,
    };
    await axiosInstance.post(
      searchAPI.updateCollections,
      requestsData,
      getConfig()
    );
    getCollectionData();

    setNewBookmarkPopup(false);
  };

  const handleSavedCollection = async (bookmarkId) => {
    try {
      const json_res = {
        ...articleData,
        collectionSourceId: bookmarkId,
        userId: user.userId,
        citation: citation,
      };
      console.log(json_res);
      const res = await axiosInstance.post(
        searchAPI.saveCitation,
        json_res,
        getConfig()
      );

      toast.success("Citation saved successfully!");
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchData();
  }, [params.query]);

  useEffect(() => {
    getBookmarks();
  }, []);

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <div className="wikipedia-page">
      {pages.length === 0 && (
        <div className="no-res">
          <p>No results found</p>
        </div>
      )}
      <div className="grid">
        {pages.map((page) => (
          <div key={page.url} className="books-container">
            <div>
              <div className="flex-title">
                <h3
                  onClick={() => {
                    window.open(page.url);
                  }}
                  className="title"
                >
                  {page.name}
                </h3>
              </div>
              <div className="img-container">
                <img
                  className="thumbnail-img"
                  src={page.openGraphImage.contentUrl}
                  onClick={() => {
                    window.open(page.url);
                  }}
                />
              </div>
              <p className="desc">
                {page.snippet.length > 200
                  ? `${page.snippet.substring(0, 200)}...`
                  : page.snippet}
              </p>
            </div>
            <div className="footer-icon">
              <Tooltip title="Cite this">
                <ReceiptIcon
                  className="mr-2"
                  onClick={() => {
                    dispatch(
                      setSummaryInfoData({
                        publisher: page.displayUrl.includes("britannica")
                          ? "Britannica"
                          : "Merriam Webster",
                        title: page.name,
                        published_date: getRegularDate(page.datePublished),
                        url: page.url,
                      })
                    );
                    dispatch(setCitationPopup(true));
                    dispatch(setUrl(page.url));
                  }}
                />
              </Tooltip>
              <Tooltip title="Add to my Collections">
                {bookmarkUrls && checkBookmark(page.displayUrl) ? (
                  <BookmarkIcon
                    style={{ color: "#1b99e8", right: "1rem" }}
                    onClick={() => {
                      handleClick(page);
                    }}
                  />
                ) : (
                  <div className="bookmark-section">
                    <BookmarkBorderIcon
                      onClick={() => {
                        handleClick(page);
                      }}
                    />
                  </div>
                )}
              </Tooltip>{" "}
            </div>
          </div>
        ))}
      </div>
      {newBookmarkPopup && (
        <NewBookmark
          saveCollectionFolder={saveCollectionFolder}
          newBookmarkPopup={newBookmarkPopup}
          setNewBookmarkPopup={setNewBookmarkPopup}
        />
      )}
      <PopupSave
        data={page}
        bookmarkUrls={bookmarkUrls}
        handleDataFetch={false}
        setNewBookmarkPopup={setNewBookmarkPopup}
        selectedCollection={selectedCollection}
        setselectedCollection={setselectedCollection}
        popup={popup}
        setpopup={setpopup}
        desc={desc}
        setData={setPage}
        handleSavedCollection={handleSavedCollection}
      />
      {summaryPopup && (
        <CustomSummarize
          setDesc={setDesc}
          setIsDescExternal={setIsDescExternal}
          setSummaryText={setSummaryText}
          summaryText={summaryText}
          setSummarizePopupNa={setSummarizePopupNa}
        />
      )}
      {summarizePopup && summarizePopupNa && (
        <Summarize
          setSaveBookmarkPopup={setpopup}
          setIsDescExternal={setIsDescExternal}
          desc={desc}
          setDesc={setDesc}
          isDescExternal={isDescExternal}
          setSummaryText={setSummaryText}
          summaryText={summaryText}
          summarizePopupNa={summarizePopupNa}
          setSummarizePopupNa={setSummarizePopupNa}
        />
      )}
      {citationPopup && (
        <PopupCitation
          citationPopup={citationPopup}
          setCitationPopup={setCitationPopup}
          setBookmarkData={setPage}
          setSaveBookmarkPopup={setpopup}
          articleData={articleData}
          setArticleData={setArticleData}
          citation={citation}
          setCitation={setCitation}
        />
      )}
    </div>
  );
};

export default WikipediaPage;
